import { Card, Form } from 'react-bootstrap';
import { useEffect, useMemo, useState } from 'react';
import PlotDetails from '../../../Migration/pages/PlotDetails';
import {
    ALLOTMENT_CORRESPONDENCE,
    APPLICANT_DETAILS_I,
    APPLICANT_DETAILS_II,
    CHECKLIST_TABLE,
    DECLARATION_DETAILS,
    ENTERPRISE_DETAILS,
    PROJECT_DETAILS,
    PROMOTER_DETAILS,
    SUBLEASE_OTHER_DETAIL,
    SUB_LESSEE_DETAILS_II,
    paymentColumns
} from '../../Allotment/Allotment.const';
import GenericActionTable from '../../../../../components/moduleCommonFormik/GenericActionTable';
import { ErrorMessage, Field, useFormikContext } from 'formik';
import Editor from '../../../../../components/ContentEditor';
import { POST, requestInfo } from '../../../../../services/modulesServices/userManagement.api';
import GenericCommonTextField from '../../../../../components/moduleCommonFormik/GenericCommonTextField.component';
import _ from 'lodash';
import Declaration from '../../Allotment/Declaration';
import ApplicantDetails from '../../Allotment/ApplicantDetails';
import EnterpriseDetails from '../../Allotment/EnterpriseDetails';
import { DECLARATION_LABEL, LESSE_APPLICANT_DETAILS_I, plotOtherField, SUB_LEASE_CORRESPONDENCE, SUB_LEASE_ORDER_CORRESPONDENCE } from '../SubLeaseConst';
import LesseeDetails from '../LesseeDetails';
import SubLesseeDetailsSecond from '../SubLesseeDetailsA1';
import GenericFileUploadField from '../../../../../components/moduleCommonFormik/GenericFileUpload.component';
import { WorkflowPaymentDetails } from '../../WorkflowPaymentDetails';
import GenericFormCard from '../../../../../components/moduleCommonFormik/GenericFormCard.component';
import { getLetter, onClickCheckBox, scrollToSection } from '../../../../../utils/utils';
import RevertAdditionalDetails from '../../Allotment/Workflow/RevertAdditionalDetails';

export const SubLeaseWorkflowCorrespondence = ({
    dropdownData,
    dropdownDataPlot,
    setDropdownDataPlot,
    ownershipDetails,
    setOwnershipDetails,
    isChecked,
    handleCheckboxChange,
    nicDetails,
    setNicDetails,
    controllingOwnership,
    checkListRowData,
    vacantPlotData,
    rowData,
    setRowData,
    applicationNumber,
    status,
    content,
    setContent,
    paymentRowData,
    disabled,
    designation,
    auctionType,
    fileStoreId,
    isCheckedSubLeaseDetails,
    setIsCheckedSubLeaseDetails,
    handleCheckboxChangeSubLeaseDetails,
    transactionDetails,
    readOnly,
    subleaseOrder,
    applicationReverted,
    fieldsDropdown,
    onRemoveAdditionalDetails
}: any) => {
    const getUserDetails = JSON.parse(localStorage.getItem('user') || '{}');
    const userDesignationGM = getUserDetails.designation === 'GM';
    const [openSection, setOpenSection] = useState<string>('subLeasetDetails');
    const [showOwnershipModal, setShowOwnershipModal] = useState(false);
    const [defaultChecked, setDefaultChecked] = useState<boolean>(true);

    const { values, touched, errors, setFieldValue } = useFormikContext<any>();

    useEffect(() => {
        applicationReverted && openSection !== 'additionalDetails' && onSectionChange('additionalDetails');
    }, [applicationReverted]);

    const SUB_LEASE_CORRESPONDENCE_ALL = useMemo(
        () =>
            status === 'PENDING' || status === 'SCRUTINY_DONE'
                ? [
                      ...(!subleaseOrder ? SUB_LEASE_CORRESPONDENCE : SUB_LEASE_ORDER_CORRESPONDENCE),
                      {
                          title: !subleaseOrder ? 'F - Sublease Order Notes' : 'E - Sublease Order Notes',
                          field: 'subleaseOrderNotes'
                      },
                      ...(!subleaseOrder && values.additionalDetails?.length
                          ? [
                                {
                                    title: `${getLetter(SUB_LEASE_CORRESPONDENCE.length)} - Additional Details`,
                                    field: 'additionalDetails'
                                }
                            ]
                          : [])
                  ]
                : status === 'REJECTION_PENDING'
                  ? [
                        ...(!subleaseOrder ? SUB_LEASE_CORRESPONDENCE : SUB_LEASE_ORDER_CORRESPONDENCE),
                        {
                            title: !subleaseOrder ? 'F - Rejection Order' : 'E - Sublease Order Notes',
                            field: 'subleaseOrderNotes'
                        },
                        ...(!subleaseOrder && values.additionalDetails?.length
                            ? [
                                  {
                                      title: `${getLetter(SUB_LEASE_CORRESPONDENCE.length)} - Additional Details`,
                                      field: 'additionalDetails'
                                  }
                              ]
                            : [])
                    ]
                  : !subleaseOrder
                    ? values.additionalDetails?.length
                        ? [
                              ...SUB_LEASE_CORRESPONDENCE,
                              {
                                  title: `${getLetter(SUB_LEASE_CORRESPONDENCE.length - 1)} - Additional Details`,
                                  field: 'additionalDetails'
                              }
                          ]
                        : SUB_LEASE_CORRESPONDENCE
                    : SUB_LEASE_ORDER_CORRESPONDENCE,
        [values.additionalDetails]
    );

    const onSectionChange = (currentSection: string) => {
        let previousSection = openSection;
        if (previousSection === currentSection) setOpenSection('');
        else setOpenSection(currentSection);

        scrollToSection(checkListRowData, defaultChecked, SUB_LEASE_CORRESPONDENCE_ALL, currentSection);
    };

    const renderDeclarationDetails = () => {
        return (
            <Declaration
                isChecked={isChecked}
                hideCard={true}
                declarationList={DECLARATION_LABEL}
                handleCheckboxChange={(e: any) => handleCheckboxChange(e)}
                fileStoreId={fileStoreId}
                applicantName={'Lessee'}
            ></Declaration>
        );
    };

    const renderNoteDetails = () => {
        return (
            <>
                <div>
                    <Form.Group>
                        <div className='col-lg-12 my-1 px-4 py-4'>
                            <Editor setContent={setContent} content={content} readOnly={readOnly} />
                        </div>
                    </Form.Group>
                </div>
            </>
        );
    };

    const renderPaymentDetails = () => {
        return (
            <>
                <div className='px-4 py-4'>
                    <WorkflowPaymentDetails transactionDetails={transactionDetails} paymentColumns={paymentColumns} paymentRowData={paymentRowData} />
                </div>
            </>
        );
    };

    const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const numericValue = e.target.value.replace(/[^0-9.-]/g, '');
        e.target.value = numericValue;
        setFieldValue('highestBidRate', numericValue);
    };

    const newApplicantDetailII = APPLICANT_DETAILS_II.map((val: any) => ({
        ...val,
        formData: val.formData?.map((field: any) => {
            const { isDisabled, ...rest } = field;
            return rest;
        })
    }));

    const lesseeApplicantDetails = useMemo(() => LESSE_APPLICANT_DETAILS_I?.map((val: any) => ({ ...val, formData: val?.formData?.map((item: any) => ({ ...item, isDisabled: true })) })), []);
    const subLesseeDetails = useMemo(() => SUB_LESSEE_DETAILS_II?.map((val: any) => ({ ...val, formData: val?.formData?.map((item: any) => ({ ...item, isDisabled: true })) })), []);
    const subLeaseOtherDetails = useMemo(() => SUBLEASE_OTHER_DETAIL?.map((val: any) => ({ ...val, formData: val?.formData?.map((item: any) => ({ ...item, isDisabled: true })) })), []);
    const plotOtherFieldDisabled = useMemo(() => plotOtherField?.map((val: any) => ({ ...val, formData: val?.formData?.map((item: any) => ({ ...item, isDisabled: true })) })), []);
    const enterpriseDetails = useMemo(() => ENTERPRISE_DETAILS?.map((val: any) => ({ ...val, formData: val?.formData?.map((item: any) => ({ ...item, isDisabled: true })) })), []);
    const projectDetails = useMemo(() => PROJECT_DETAILS?.map((val: any) => ({ ...val, formData: val?.formData?.map((item: any) => ({ ...item, isDisabled: true })) })), []);
    const declarationDetails = useMemo(() => DECLARATION_DETAILS?.map((val: any) => ({ ...val, formData: val?.formData?.map((item: any) => ({ ...item, isDisabled: true })) })), []);

    return (
        <>
            <Card className='checklist-outer mb-4 mx-3'>
                <div className='row my-3 px-3 py-2 '>
                    {checkListRowData?.length && status !== 'APPROVED' ? (
                        <div className='col-sm-12 collapsible_box collapsible_box_checklist pb-3 align-items-center pb-2'>
                            <input type='checkbox' id='checklists' name='checklists' defaultChecked={defaultChecked} onClick={e => onClickCheckBox(e, setDefaultChecked)} />
                            <label htmlFor='checklists' className='d-flex collapsible_box_label align-items-center pb-0 justify-content-between text-black  fw-bold'>
                                Condition/Check list
                            </label>
                            <div className='form_fields px-2'>
                                <GenericActionTable columns={CHECKLIST_TABLE} hideSearchBar={true} rowData={checkListRowData} />
                            </div>
                        </div>
                    ) : (
                        ''
                    )}

                    {SUB_LEASE_CORRESPONDENCE_ALL.map((val: any, index: number) => {
                        return (
                            <div className={`col-sm-12 collapsible_box noting-collapsible-box align-items-center py-3 px-0`}>
                                <input type='checkbox' id={`${val.field}Form`} name={`${val.field}Form`} checked={openSection === val.field} onChange={() => onSectionChange(val.field)} />
                                <label
                                    htmlFor={`${val.field}Form`}
                                    className='px-4 d-flex collapsible-box-label col-sm-12 checklist-heading noting-collapsible-box-label align-items-center justify-content-between'
                                >
                                    {val.title}
                                </label>
                                {val.title === 'A1 - Sub-Lessee Details' && openSection === 'subLeasetDetails' && (
                                    <ApplicantDetails
                                        dropdownOptions={dropdownData}
                                        setOwnershipDetails={setOwnershipDetails}
                                        controllingOwnershipResponse={controllingOwnership}
                                        ownershipDetails={ownershipDetails}
                                        showOwnershipModal={showOwnershipModal}
                                        setShowOwnershipModal={setShowOwnershipModal}
                                        applicantDetails1={lesseeApplicantDetails}
                                        applicantDetails2={subLesseeDetails}
                                        promoterDetails={subLeaseOtherDetails}
                                        hideBankDetails={true}
                                        isWorkflow={true}
                                    ></ApplicantDetails>
                                )}
                                {val.title === 'A2 - Lessee Details' && openSection === 'lesseDetails' && (
                                    <Card.Body>
                                        <LesseeDetails />
                                    </Card.Body>
                                )}
                                {val.title === 'A3 - Sub-Lease Details' && openSection === 'subLeasetDetails2' && (
                                    <Card.Body>
                                        <SubLesseeDetailsSecond
                                            isCheckedSubLeaseDetails={isCheckedSubLeaseDetails}
                                            setIsCheckedSubLeaseDetails={setIsCheckedSubLeaseDetails}
                                            handleCheckboxChange={handleCheckboxChangeSubLeaseDetails}
                                            isDisabled={true}
                                        />
                                    </Card.Body>
                                )}
                                {val.title === 'B - Plot Details' && openSection === 'plotDetails' && (
                                    <>
                                        <Card.Body>
                                            {/* <div className='typeof-plot-details ps-2 fs-5 mt-4 mb-2'>Applied Plot</div> */}
                                            <PlotDetails dropdownData={dropdownDataPlot} isFieldDisable={true} setDropdownData={setDropdownDataPlot} hideCard={true} />
                                            {plotOtherFieldDisabled?.map((val: any) => <GenericFormCard {...val} />)}
                                        </Card.Body>
                                    </>
                                )}
                                {val.title === 'C - Enterprise Details' && openSection === 'enterpriseDetails' && (
                                    <EnterpriseDetails
                                        enterpriseDetails={enterpriseDetails}
                                        enterpriseProjectDetails={projectDetails}
                                        declarationDetails={declarationDetails}
                                        dropdownOptions={dropdownData}
                                        nicDetails={nicDetails}
                                        setNicDetails={setNicDetails}
                                        isDisabled={true}
                                    ></EnterpriseDetails>
                                )}
                                {!subleaseOrder && val.title === 'D - Self Declaration' && openSection === 'selfDeclaration' && renderDeclarationDetails()}
                                {(!subleaseOrder ? val.title === 'E - Payment Details' : val.title === 'D - Payment Details') && openSection === 'paymentDetails' && renderPaymentDetails()}
                                {(!subleaseOrder ? val.title === 'F - Sublease Order Notes' : val.title === 'E - Sublease Order Notes') && openSection === 'subleaseOrderNotes' && renderNoteDetails()}
                                {val.title?.includes('Additional Details') && openSection === 'additionalDetails' && (
                                    <RevertAdditionalDetails
                                        fieldsDropdown={fieldsDropdown}
                                        onRemoveAdditionalDetails={onRemoveAdditionalDetails}
                                        applicationReverted={applicationReverted}
                                        dropdownData={dropdownData}
                                    />
                                )}
                            </div>
                        );
                    })}
                </div>
            </Card>
        </>
    );
};
